export default __webpack_public_path__ + "static/media/Home_BG-02.17064729.png";